/* eslint-disable import/prefer-default-export */
/* eslint-disable func-names */

import { select } from 'redux-saga/effects';
// import {
//   apiCurrencyCovert,
//   apiCommonService,
// } from "../components/config/parameters";
import { callApiServiceCommon } from './service-common';

const blogApi = 'https://blog.autoketing.com/autoketingblog-posts';
const apiCurrencyCovert = process.env.REACT_APP_API_CURRENCY;
const apiCommonService = process.env.REACT_APP_API_COMMON;

function getVal(str) {
  const v = window.location.search.match(new RegExp(`(?:[?&]${str}=)([^&]+)`));
  return v ? v[1] : undefined;
}

export const shopUrl = getVal('shop');
const apiGetShopSettings = `${apiCurrencyCovert}get-settings`;
const apiSaveSettings = `${apiCurrencyCovert}save-settings`;
const apiPositionBilling = `${apiCurrencyCovert}shopify-billing`;
const apiBillingPro = `${apiCurrencyCovert}cur-register-charge`;
const apiDowngradeBillingPro = `${apiCurrencyCovert}cur-cancel-charge`;
const apiTicKit = `${apiCommonService}create-ticket`;
const apiGetShopInfo = `${apiCommonService}ak/get-shop-info`;

const apiGetCountTolal = `${apiCurrencyCovert}cur/get-statistic-count-total`;
const apiGetDateTime = `${apiCurrencyCovert}cur/get-statistic-date-to-date`;

const apiGetShopSettingsTranslate = `${apiCurrencyCovert}cur/get-settings-translate`;
const apiSaveSettingsTranslate = `${apiCurrencyCovert}cur/save-settings-translate`;

const shopSetting = state => state.get('currencyReducer');
const shopSettingTranslate = state => state.get('translationReducer');

function* getCountTolal() {
  const payload = {
    method: 'GET',
    params: {},
    url: apiGetCountTolal
  };
  return yield callApiServiceCommon(payload);
}
function* getDateTime(data) {
  const payload = {
    method: 'GET',
    params: {
      start_date: data.startDate,
      end_date: data.endDate
    },
    url: apiGetDateTime
  };
  return yield callApiServiceCommon(payload);
}

function* saveCurrencySetting() {
  function getIndex(value, arr, prop) {
    for (let i = 0; i < arr.size; i++) {
      if (arr.getIn([i, prop]) === value) {
        return i;
      }
    }
    return -1; // to handle the case where the value doesn't exist
  }

  const data = yield select(shopSetting);
  let selected = data.get('selectedCurrencies');
  const i = getIndex(data.get('currency'), selected, 'value');
  const j = getIndex(data.get('currency'), data.get('listCurrencies'), 'value');
  if (i < 0 && j >= 0) {
    selected = selected.unshift(data.getIn(['listCurrencies', j]));
  }

  const payload = {
    method: 'POST',
    params: {
      theme: data.get('currencyTheme'),
      background_color: data.get('backgroundColor'),
      text_color: data.get('textColor'),
      background_color_hover: data.get('hoverBackgroundColor'),
      background_color_select: data.get('selectedBackgroundColor'),
      text_color_select: data.get('selectedTextColor'),
      text_color_hover: data.get('hoverTextColor'),
      position: data.get('position'),
      display_currency: data.get('displayCurrencyCode'),
      remove_decimals: data.get('removeDecimals'),
      round_decimals: data.get('roundDecimals'),
      round_to: data.get('roundTo'),
      message: data.get('checkoutStatus'),
      message_text: data.get('messageText'),
      message_color: data.get('messageColor'),
      message_background_color: data.get('messageBackgroundColor'),
      price_original_show: data.get('OriginalPriceStatus'),
      price_color: data.get('priceColor'),
      price_background_color: data.get('priceBackgroundColor'),
      json_data: JSON.stringify(selected),
      currency_selected: JSON.stringify(data.get('currencies')),
      auto_convert: data.get('autoConvert'),
      activated: data.get('appStatus'),
      currency_status: data.get('appStatusCurrency'),
      show_currency_position: data.get('positionStatus'),
      progress_bar_setting: data.get('progressBarSetting') <= 33 ? 66 : data.get('progressBarSetting'),
      currency: data.get('currency'),
      add_customer_currency: data.get('addCustomerCurrency'),
      is_show_desktop: data.get('showDesktop'),
      is_show_mobile: data.get('showMobile'),
      list_rounding_rule: JSON.stringify(data.get('listRoundingRule')),
      position_float: data.get('positionFloat'),
      flags_size: data.get('flagSize'),
      collection_page: data.get('collectionPage'),
      custom_link: data.get('customLink'),
      home_page: data.get('homePage'),
      products_page: data.get('productsPage'),
      cart_page: data.get('cartPage'),
      translate_status: data.get('appStatusTranslate'),
      currency_beside: data.get('currencyBeside')
    },
    url: apiSaveSettings
  };
  return yield callApiServiceCommon(payload);
}

function* saveTranslateSetting() {
  const data = yield select(shopSettingTranslate);
  const selected = data.get('selectedTranslate');
  const payload = {
    method: 'POST',
    params: {
      translate_status: data.get('appStatusTranslate'),
      auto_convert: data.get('autoConvert'),
      background_color: data.get('backgroundColor'),
      background_color_hover: data.get('hoverBackgroundColor'),
      border_color: data.get('borderColor'),
      border_width: data.get('borderWidth'),
      font_size: data.getIn(['font', 'size']),
      font_weight: data.getIn(['font', 'weight']),
      is_show_desktop: data.get('showDesktop'),
      is_show_mobile: data.get('showMobile'),
      json_data: JSON.stringify(selected),
      list_display: data.get('popDropdown'),
      margin_bottom: data.getIn(['margin', 'bottom']),
      margin_left: data.getIn(['margin', 'left']),
      margin_right: data.getIn(['margin', 'right']),
      margin_top: data.getIn(['margin', 'top']),
      position: data.get('position'),
      position_float: data.get('positionFloat'),
      show_translate_position: data.get('positionStatus'),
      text_color: data.get('textColor'),
      theme: data.get('translationTheme'),
      translate: data.get('translate'),
      translate_selected: JSON.stringify(data.get('translation')),
      progress_bar_translate: data.get('progressBarTranslate') <= 50 ? 100 : data.get('progressBarTranslate')
    },
    url: apiSaveSettingsTranslate
  };
  return yield callApiServiceCommon(payload);
}

function* createContactPosition() {
  const data = yield select(shopSetting);
  const payload = {
    method: 'post',
    params: {
      name: data.get('name'),
      email: data.get('email'),
      subject: `Contact Currency Position-${shopUrl}`,
      message: data.get('contactCheckout'),
      group_id: '42000097107'
    },
    url: apiTicKit
  };
  return yield callApiServiceCommon(payload);
}

function* createContactCheckout() {
  const data = yield select(shopSetting);
  const payload = {
    method: 'POST',
    params: {
      name: data.get('name'),
      email: data.get('email'),
      subject: `Contact Currency Checkout-${shopUrl}`,
      message: data.get('contactCheckout'),
      group_id: '42000097107'
    },
    url: apiTicKit
  };
  return yield callApiServiceCommon(payload);
}

function* submitIssue(payload) {
  const data = yield select(shopSetting);
  const submit = {
    method: 'POST',
    params: {
      name: data.get('name'),
      email: data.get('email'),
      subject: `${payload.payload.issueSubjectValue}-${shopUrl}`,
      message: payload.payload.issueDetailValue,
      group_id: '42000097107'
    },
    url: apiTicKit
  };
  return yield callApiServiceCommon(submit);
}
function* getShopSettingsTranslate() {
  const payload = {
    method: 'GET',
    params: { shop_id: shopUrl },
    url: apiGetShopSettingsTranslate
  };
  return yield callApiServiceCommon(payload);
}

function* getShopSettings() {
  const payload = {
    method: 'GET',
    params: { shop_domain: shopUrl },
    url: apiGetShopSettings
  };
  return yield callApiServiceCommon(payload);
}

function* getShopInfo() {
  const payload = {
    method: 'GET',
    params: { shop_domain: shopUrl, app_code: 'cur' },
    url: apiGetShopInfo
  };
  return yield callApiServiceCommon(payload);
}

function* upgradePackage(payload) {
  const data = {
    method: 'POST',
    params: {
      subject: `Contact Currency ${payload.payload.contact}-${shopUrl}`,
      message: payload.payload.message
    },
    url: apiPositionBilling
  };
  return yield callApiServiceCommon(data);
}

function* upgradePackagePro() {
  const data = {
    method: 'POST',
    params: {
      price_name: 'premium'
    },
    url: apiBillingPro
  };
  return yield callApiServiceCommon(data);
}

function* downgradePackagePro() {
  const data = {
    method: 'POST',
    params: {},
    url: apiDowngradeBillingPro
  };
  return yield callApiServiceCommon(data);
}

function* getCurrencyRate() {
  const payload = {
    method: 'GET',
    url: `https://api-v1-autoketing.autoketing.org/asset-production-autoketing/currency-convert/sdk/base_usd_currency.json?${new Date().getTime()}`,
    params: {}
  };
  return yield callApiServiceCommon(payload);
}
export function* getListBlogServer(number) {
  const payload = {
    method: 'GET',
    url: `${blogApi}`,
    params: {
      'post-per-page': number
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* upgradePlanPackageService(plan) {
  const payload = {
    method: 'POST',
    url: `${apiCurrencyCovert}cur/register-charge`,
    params: {
      price_name: plan || 'BASIC',
      bundle: false,
      year_charge: false,
      apply_sales_event: false
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* changeAppStatusService(status) {
  const payload = {
    method: 'POST',
    url: `${apiCurrencyCovert}on-off-app`,
    params: {
      status_app: status
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* changeAppStatusCurrencyService(status) {
  const payload = {
    method: 'POST',
    url: `${apiCurrencyCovert}cur/on-off-currency`,
    params: {
      currency_status: status
    }
  };
  return yield callApiServiceCommon(payload);
}

export function* changeAppStatusTranslateService(status) {
  const payload = {
    method: 'POST',
    url: `${apiCurrencyCovert}cur/on-off-translate`,
    params: {
      translate_status: status
    }
  };
  return yield callApiServiceCommon(payload);
}

export const Service = {
  getShopSettingsTranslate,
  saveTranslateSetting,
  getShopSettings,
  saveCurrencySetting,
  createContactPosition,
  createContactCheckout,
  getShopInfo,
  submitIssue,
  upgradePackage,
  upgradePackagePro,
  downgradePackagePro,
  getCurrencyRate,
  upgradePlanPackageService,
  getCountTolal,
  getDateTime
};
